import YurtSVG from "../../../../../YurtSVG";
import Moment from "react-moment";
import styled from "styled-components";

import { findTax, findTotalTax, findFundsReceived } from "../../functions";
import { formatter } from "../../../constants";
import PreviewKit from "./Kit";

let today = Date.now();

const niceGrey = "rgb(120, 120, 120)";

const Container = styled.div`
  background: white;
  padding: 40px;
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 40px;
  page-break-after: avoid;
`;

const Header = styled.div`
  display: flex;
  svg {
    fill: ${({ color }) => color};
  }
`;

const Tag = styled.div`
  font-size: 16px;
  padding: 0px 20px;
  color: ${niceGrey};
`;

const Title = styled.div`
  color: black;
  font-weight: 700;
  font-size: 36px;
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
  margin-bottom: 15px;
  text-transform: capitalize;
`;

const DateTitle = styled.small`
  margin-left: 40px;
  font-size: 15px;
`;

const Details = styled.div`
  width: 100%;
  background: ${({ color }) => color};
  border-radius: 5px;
  padding: 20px;
  display: flex;
  *,
  p {
    color: white !important;
  }
`;

const Personal = styled.div`
  width: 50%;
  p {
    font-size: 16px !important;
    margin: 0px !important;
  }
`;

const Name = styled.div`
  font-size: 30px;
  font-weight: 700;
`;

const Address = styled.div`
  p {
    font-size: 16px !important;
    padding: 0px !important;
    margin: 0px !important;
  }
  width: 25%;
`;

const DatesContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const MoneyDates = styled.div`
  border: 2px solid #798b7922;
  display: flex;
  justify-content: space-between;
  margin: 20px 0px;
  border-radius: 5px;
  * {
    font-size: 18px;
  }
`;
const DateItem = styled.div`
  min-width: 20%;
  padding: 20px;
`;

const DateValue = styled.div`
  color: ${niceGrey};
`;

const DateAmount = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  color: ${niceGrey};
  span {
    color: ${({ color }) => color} !important;
    font-weight: 700;
    padding-left: 10px;
  }
`;

const ProductionDates = styled.div`
  border: 2px solid #798b7922;
  display: flex;
  justify-content: space-evenly;
  margin: 20px 0px;
  border-radius: 5px;
  width: max-content;
  * {
    font-size: 18px;
  }
  /* flex: 2; */
`;

const TableTop = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  padding: 10px;
  border-radius: 3px;
  justify-content: space-between;
  div {
    background: ${({ color }) => color};
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 3px;
    opacity: 0.2;
  }
  p {
    margin: 0px;
    font-weight: 900;
    font-size: 20px !important;
  }
`;

const Tax = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  font-size: 20px;
  font-weight: 700;
  color: #a0a0a0;
  span {
    padding: 0 20px;
    color: grey;
  }
`;

const Total = styled.div`
  border: 2px solid black;
  display: flex;
  justify-content: space-between;
  padding: 14px;
  border-radius: 3px;
  font-size: 18px;
  color: black;
  font-weight: 900;
`;

const SubTotal = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 14px;
  border-radius: 3px;
  font-size: 18px;
  color: grey;
  font-weight: 900;
  border: 1px solid grey;
  margin-top: 10px;
`;

const Important = styled.div`
  font-size: 16px;
  padding: 10px 0;
  text-align: right;
`;

const Notes = styled.div`
  position: relative;
  display: flex;
  padding: 20px;
  border: 2px solid grey;
  color: grey;
  font-size: 20px;
`;

const NoteHeader = styled.div`
  position: absolute;
  background: white;
  padding: 0 2px;
  top: -8px;
  left: 10px;
  color: grey;
  font-size: 16px;
`;

const Terms = styled.div`
  display: flex;
  padding: 20px 0;
  justify-content: space-between;
  margin-bottom: 30px;
`;

const PSA = styled.div`
  font-size: 20px;
  color: grey;
  width: 48%;
`;

const Signature = styled.div`
  width: 48%;
  font-size: 24px;
`;

const Sign = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
  font-weight: 700;
  span {
    width: 60%;
    border-bottom: 2px solid black;
  }
`;

const Footer = styled.div`
  font-size: 8px;
`;

const BalanceDue = styled.div`
  border: 2px solid black;
  display: flex;
  justify-content: space-between;
  padding: 7px;
  border-radius: 3px;
  font-size: 18px;
  color: ${({ color }) => color};
  font-weight: 900;
`;

const Item = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  padding-left: 5px;
  font-size: 18px;
  font-weight: 700;
  color: grey;
  border-top: 1px solid #ededed;
`;

const ItemTitle = styled.div`
  text-transform: capitalize;
`;
const ItemAmount = styled.div``;

const Line = styled.div`
  width: 100%;
  border: 1px solid black;
  margin: 20px 0;
`;

const Printable = ({ value, document, colors, showDates }) => {
  const color = colors[document.type];

  const {
    firstName,
    lastName,
    phoneNumber,
    email,
    mailingStreetAddress,
    mailingCity,
    mailingRegion,
    mailingZipCode,
    mailingCountry,
    deliveryStreetAddress,
    deliveryCity,
    deliveryCountry,
    deliveryRegion,
    deliveryZipCode,
  } = value;

  const {
    depositDue,
    fiftyDue,
    fullDue,
    productionDate,
    shipDate,
    title,
    tax,
    notes,
    psa,
    psaDefault,
    kits,
    type,
  } = document;

  return (
    <Container>
      <Header color={color}>
        <YurtSVG width="2.5rem" />

        <Tag>
          <b>Smiling Woods Yurts</b>
          <br />
          28 Horizon Flat Rd
          <br />
          Winthrop, WA 98862
          <br />
          (509) 996-9878
          <br />
          accounting@smilingwoodsyurts.com
          <br />
          smilingwoods.com
        </Tag>
      </Header>

      <Title>
        {title}
        <DateTitle>
          <Moment date={today} format="MM/DD/YY" />
        </DateTitle>
      </Title>

      <Details color={color}>
        <Personal>
          <Name>
            {firstName} {lastName}
          </Name>
          <p>{phoneNumber}</p>
          <p>{email}</p>
        </Personal>
        <Address>
          <p>
            <b>MAILING ADDRESS</b>
          </p>
          <p>{mailingStreetAddress}</p>
          <p>
            {mailingCity} {mailingRegion}
          </p>
          <p>
            {mailingZipCode} {mailingCountry}
          </p>
        </Address>
        <Address>
          <p>
            <b>SHIPPING ADDRESS</b>
          </p>
          <p>{deliveryStreetAddress}</p>
          <p>
            {deliveryCity} {deliveryRegion}
          </p>
          <p>
            {deliveryZipCode} {deliveryCountry}
          </p>
        </Address>
      </Details>
      {showDates && (
        <DatesContainer>
          <MoneyDates>
            {type !== "final invoice" && (
              <>
                <DateItem>
                  <p>
                    <b>DEPOSIT DUE DATE</b>
                  </p>
                  <DateValue>{depositDue}</DateValue>
                  <DateAmount color={color}>
                    DUE: <span>$6,000</span>
                  </DateAmount>
                </DateItem>
                <DateItem>
                  <p>
                    <b>50% DUE DATE</b>
                  </p>
                  <DateValue>{fiftyDue}</DateValue>
                  <DateAmount color={color}>
                    DUE:{" "}
                    <span>{formatter.format(findTotalTax(kits, tax) / 2)}</span>
                  </DateAmount>
                </DateItem>
              </>
            )}
            <DateItem>
              <p>
                <b>BALANCE DUE</b>
              </p>
              <DateValue>
                {fullDue ? (
                  fullDue
                ) : (
                  <Moment
                    date={new Date(productionDate).getTime() - 14 * 86400000}
                    format="M/D/YYYY"
                  />
                )}
              </DateValue>

              {type !== "final invoice" && (
                <DateAmount color={color}>
                  DUE:{" "}
                  <span>{formatter.format(findTotalTax(kits, tax) / 2)}</span>
                </DateAmount>
              )}
            </DateItem>
          </MoneyDates>

          <ProductionDates>
            <DateItem>
              <p>
                <b>PRODUCTION DATE</b>
              </p>
              <DateValue>{productionDate}</DateValue>
            </DateItem>
            <DateItem>
              <p>
                <b>SHIP DATE</b>
              </p>
              <DateValue>{shipDate}</DateValue>
            </DateItem>
          </ProductionDates>
        </DatesContainer>
      )}

      <TableTop color={color}>
        <div></div>
        <p>ITEM</p>
        <p>AMOUNT</p>
      </TableTop>

      {kits.map((yurt, i) => (
        <PreviewKit
          key={"yurt" + i}
          kit={yurt}
          i={i}
          kitsAmount={kits.length}
          color={color}
        />
      ))}

      <Line></Line>

      <SubTotal color={color}>
        <div>SUB-TOTAL</div>
        <div>
          {formatter.format(findTotalTax(kits, tax) - findTax(kits, tax))}
        </div>
      </SubTotal>

      <Tax>
        <div>Sales Tax</div>

        <div>
          <span>({tax}%)</span> {formatter.format(findTax(kits, tax))}
        </div>
      </Tax>

      <Total color={color}>
        <div>FULL TOTAL</div>
        <div>{formatter.format(findTotalTax(kits, tax))}</div>
      </Total>

      {kits.map((yurt, i) => (
        <div key={i}>
          {yurt.items
            .filter((e) => e.fundsReceived)
            .map((item, k) => (
              <Item>
                <ItemTitle>{item.title}</ItemTitle>
                <ItemAmount>{formatter.format(item.amount)}</ItemAmount>
              </Item>
            ))}
        </div>
      ))}

      {kits.filter(({ items }) =>
        items.some(({ fundsReceived }) => fundsReceived)
      ).length ? (
        <BalanceDue color={color}>
          <div>BALANCE DUE</div>
          <div>
            {formatter.format(
              findTotalTax(kits, tax) + findFundsReceived(kits)
            )}
          </div>
        </BalanceDue>
      ) : (
        <></>
      )}

      {document.type === "purchase agreement" && (
        <Important>These prices do not reflect the final invoice*</Important>
      )}

      <Notes style={{ display: notes ? "" : "none" }}>
        <NoteHeader>Notes</NoteHeader>
        <div>{notes}</div>
      </Notes>

      <Terms>
        <PSA>
          {psaDefault ? (
            <div>
              50% of the estimated amount will be due 90 days before your
              production start date. The remaining balance will be due after
              design completion and before the production start date.
            </div>
          ) : (
            <div>{psa}</div>
          )}
        </PSA>
        <Signature>
          <Sign>
            Accepted By: <span></span>
          </Sign>

          <Sign>
            Signed Date: <span></span>
          </Sign>

          <Sign>
            Signature: <span></span>
          </Sign>
        </Signature>
      </Terms>
      <Footer>
        This agreement is subject to the Terms and Conditions as written on the
        subsequent pages.
      </Footer>
    </Container>
  );
};

export default Printable;
